"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold lg:hidden" };
const _hoisted_3 = {
    key: 0,
    class: "relative"
};
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "font-bold text-right" };
const _hoisted_6 = {
    key: 1,
    class: "absolute p-2 bg-blue rounded min-w-full -right-4 text-white shadow z-10 text-center text-xl"
};
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-tyrestack" }, null, -1);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = {
    key: 1,
    class: "grid grid-flow-col"
};
const _hoisted_10 = { class: "font-bold text-right" };
const _hoisted_11 = {
    key: 2,
    class: "grid grid-flow-col"
};
const _hoisted_12 = { class: "font-bold text-right" };
const _hoisted_13 = {
    key: 3,
    class: "grid grid-flow-col"
};
const _hoisted_14 = { class: "font-bold text-right" };
const _hoisted_15 = {
    key: 4,
    class: "grid grid-flow-col"
};
const _hoisted_16 = { class: "font-bold text-right" };
const _hoisted_17 = { key: 5 };
const _hoisted_18 = {
    key: 0,
    type: "button",
    class: "button-limited"
};
const _hoisted_19 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-info-circle" })
], -1);
const _hoisted_20 = {
    key: 1,
    type: "button",
    class: "button-orderable"
};
const _hoisted_21 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-info-circle" })
], -1);
const _hoisted_22 = {
    key: 6,
    class: "grid grid-flow-col"
};
const _hoisted_23 = {
    key: 0,
    class: "marso-icon-chevron-up"
};
const _hoisted_24 = {
    key: 1,
    class: "marso-icon-chevron-down"
};
const _hoisted_25 = {
    key: 0,
    class: "font-bold text-right"
};
const _hoisted_26 = {
    key: 1,
    class: "font-bold text-right"
};
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
const productListStore_1 = require("../../../stores/product/list/productListStore");
const vue_router_1 = require("vue-router");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'StockCell',
    props: {
        products: null,
        product: null,
        visiblePriceOptions: null
    },
    setup(__props) {
        const props = __props;
        const tagStore = (0, tagStore_1.useTagStore)();
        const productListStore = (0, productListStore_1.useProductListStore)();
        const router = (0, vue_router_1.useRouter)();
        const stockMax = 50;
        const loadProductPriceOptions = (router, id) => {
            return (0, fetch_1.default)(router.resolve({ name: 'shop_products_supplier_delivery_days', params: { id } }).href);
        };
        const togglePriceOptions = (id) => {
            var _a;
            if (props.visiblePriceOptions.has(id) && props.visiblePriceOptions.get(id)) {
                // ha lathato, akkor vegyuk le
                props.visiblePriceOptions.set(id, false);
                return;
            }
            let l = (_a = props.products) === null || _a === void 0 ? void 0 : _a.length;
            for (let i = 0; i < l; i++) {
                if (id === props.products[i].id) {
                    if (props.visiblePriceOptions.has(id)) {
                        // ha mar be volt toltve, akkor nem kell ujratolteni
                        props.visiblePriceOptions.set(id, true);
                        return;
                    }
                    // ha pedig meg nem volt betoltve akkor toltsuk be
                    loadProductPriceOptions(router, id).then((priceOptions) => {
                        // eslint-disable-next-line vue/no-mutating-props
                        props.products[i].priceOptions = priceOptions;
                        props.visiblePriceOptions.set(id, true);
                    });
                    return;
                }
            }
        };
        const calculatePriceOptionsStock = (priceOptions) => {
            let stock = 0;
            priceOptions.forEach((priceOption) => {
                if (priceOption.stock) {
                    stock = stock + priceOption.stock;
                }
            });
            return stock;
        };
        const isStockMax = (stocks) => {
            return stocks > stockMax;
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.stockColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `stock-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('stock', 'Stock', 'stock_cell')), 1),
                    (0, vue_2.createElementVNode)("div", null, [
                        (__props.product.stocks.stockDetailsStatus === '')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                (__props.product.stocks.stockDetails && __props.product.stocks.stockDetails.length > 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: 0,
                                        class: "absolute p-2 bg-blue rounded min-w-full -right-4 text-white shadow z-10",
                                        onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(productListStore).hideStockDetails(__props.product.id)))
                                    }, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.product.stocks.stockDetails, (site) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: site.name,
                                                class: "grid grid-flow-col"
                                            }, [
                                                (0, vue_2.createElementVNode)("span", {
                                                    class: "whitespace-nowrap pr-2",
                                                    title: site.name
                                                }, (0, vue_2.toDisplayString)(site.name), 9, _hoisted_4),
                                                (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(site.stock), 1)
                                            ]));
                                        }), 128))
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, _hoisted_8))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.stocks.stockCountry && __props.product.stocks.stockCountry > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("span", {
                                    class: "text-blue font-bold cursor-pointer",
                                    onClick: _cache[1] || (_cache[1] = ($event) => ((0, vue_2.unref)(productListStore).showStockDetails((0, vue_2.unref)(router), __props.product.id)))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('country', 'country', 'stock_cell')), 1),
                                (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(__props.product.stocks.stockCountry) + (0, vue_2.toDisplayString)(__props.product.stocks.stockCountryMax ? '+' : ''), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.stocks.stockLocal && __props.product.stocks.stockLocal > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('local', 'of which local', 'stock_cell')), 1),
                                (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)(__props.product.stocks.stockLocal) + (0, vue_2.toDisplayString)(__props.product.stocks.stockLocalMax ? '+' : ''), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.stocks.stockManufacturer && __props.product.stocks.stockManufacturer > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('manufacturer', 'manufacturer', 'stock_cell')), 1),
                                (0, vue_2.createElementVNode)("span", _hoisted_14, (0, vue_2.toDisplayString)(__props.product.stocks.stockManufacturer) + (0, vue_2.toDisplayString)(__props.product.stocks.stockManufacturerMax ? '+' : ''), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.stocks.stockHun && __props.product.stocks.stockHun > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('hungarian', 'hungarian', 'stock_cell')), 1),
                                (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(__props.product.stocks.stockHun) + (0, vue_2.toDisplayString)(__props.product.stocks.stockHunMax ? '+' : ''), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.stocks.status)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, [
                                (__props.product.stocks.status === 'limited')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", _hoisted_18, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('limited_stock', 'Limited stock', 'stock_cell')) + " ", 1),
                                        _hoisted_19
                                    ]))
                                    : (__props.product.stocks.status === 'orderable')
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", _hoisted_20, [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('orderable', 'Orderable', 'stock_cell')) + " ", 1),
                                            _hoisted_21
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (__props.product.priceOptions.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "show-price-options text-blue font-bold cursor-pointer text-left whitespace-nowrap",
                                    type: "button",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (togglePriceOptions(__props.product.id)))
                                }, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('priceOptions', 'price options', 'stock_cell')) + " ", 1),
                                    (__props.visiblePriceOptions.get(__props.product.id))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_23))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_24))
                                ]),
                                (isStockMax(calculatePriceOptionsStock(__props.product.priceOptions)))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_25, (0, vue_2.toDisplayString)(stockMax) + "+ "))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_26, (0, vue_2.toDisplayString)(calculatePriceOptionsStock(__props.product.priceOptions)), 1))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
